// @ts-nocheck
import React from "react";
import { Helmet } from "react-helmet";

const PageTitle = ({ children }) => <Helmet title={`${children} - Mob-R2`} />;
export default PageTitle;
